import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import _ from 'lodash';
import { optimizePlanQuery } from 'gqlQueries/promoRecommendation';

const errorMessage: string = 'Something went wrong!';

function useOptimismPlan({ onComplete }: { onComplete: Function }) {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);

    const [optimizePlan] = useMutation(optimizePlanQuery, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
    });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            onComplete();
            //if data present parse it
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setLoading(false);
        setError(String(error));
    }

    return {
        loading,
        error,
        setError,
        optimizePlan: (variables: any) => {
            setError(null);
            setLoading(true);
            optimizePlan(variables);
        },
    };
}

export default useOptimismPlan;
